import React from "react";
import cn from "../../lib/classnames";
import styles from "./CreditCard.module.css";
import * as models from "../../lib/api/models";

export const LG_FONT_MAX_LENGTH = 17;
export const SM_FONT_MAX_LENGTH = 20;

type Props = {
    imageAlt: string;
    imageSources: string[];
    text?: string;
    textColor: string;
    cardValue?: string;
};

export default function CreditCard({
    text = "",
    imageSources,
    imageAlt,
    textColor,
    cardValue,
}: Props) {
    const nameStyle: React.CSSProperties = {
        color: textColor,
    };

    const isMediumText = text.length > LG_FONT_MAX_LENGTH && text.length < SM_FONT_MAX_LENGTH;
    const isLongText = text.length >= SM_FONT_MAX_LENGTH;

    if (isMediumText) {
        nameStyle.transform = `scale(${1 - 0.05 * (text.length - LG_FONT_MAX_LENGTH)})`;
    } else if (isLongText) {
        nameStyle.transform = `scale(${1 - 0.05 * (SM_FONT_MAX_LENGTH - LG_FONT_MAX_LENGTH)})`;
    }

    let cardText;
    if (text && text.length) {
        cardText = text.length > SM_FONT_MAX_LENGTH ? text.substring(0, SM_FONT_MAX_LENGTH) : text;
    }

    return (
        <>
            <img
                className={styles.image}
                src={imageSources[0]}
                srcSet={
                    imageSources.length === 3
                        ? `${imageSources[0]} 1x, ${imageSources[1]} 2x, ${imageSources[2]} 3x`
                        : undefined
                }
                alt={imageAlt}
            />
            {cardText ? (
                <div
                    className={cn(
                        styles.name,
                        isMediumText || isLongText ? styles.nameSmall : undefined,
                        cardValue === models.CardSelectionOptions.BlackVisa ||
                            cardValue === models.CardSelectionOptions.BlackMC
                            ? styles.black
                            : undefined,
                    )}
                    style={nameStyle}
                >
                    {cardText}
                </div>
            ) : null}
        </>
    );
}
